import cookie from 'js-cookie';
import { Middleware } from '@spotify-internal/remote-config-core';
import { getUuid } from '@spotify-internal/remote-config-common';
const INSTALLATION_ID_COOKIE_KEY = 'sp_t';
const INSTALLATION_ID_STORAGE_KEY = 'com.spotify.rcs.installationId';
export function isValidInstallationId(id) {
    return typeof id === 'string' && id.length > 5;
}
const YEAR_IN_MS = 3600 * 24 * 366 * 1000;
export function getInstallationId(storage) {
    const sptFromCookie = cookie.get(INSTALLATION_ID_COOKIE_KEY);
    let effectiveInstallationId = sptFromCookie;
    if (effectiveInstallationId === undefined && storage) {
        const sptFromLs = storage.getItem(INSTALLATION_ID_STORAGE_KEY);
        if (isValidInstallationId(sptFromLs)) {
            effectiveInstallationId = sptFromLs;
        }
    }
    if (!isValidInstallationId(effectiveInstallationId)) {
        effectiveInstallationId = getUuid();
    }
    if (sptFromCookie !== effectiveInstallationId) {
        const cookieSet = !!cookie.set(INSTALLATION_ID_COOKIE_KEY, effectiveInstallationId, {
            expires: Date.now() + YEAR_IN_MS,
            path: '/',
        });
        if (!cookieSet && storage) {
            storage.setItem(INSTALLATION_ID_STORAGE_KEY, effectiveInstallationId);
        }
    }
    return effectiveInstallationId;
}
export const installationIdMiddleware = Middleware.fromContextProvider(({ installationId, storage }) => {
    if (isValidInstallationId(installationId)) {
        return { installationId };
    }
    return { installationId: getInstallationId(storage || localStorage) };
});
//# sourceMappingURL=installationid.js.map